<div class="mnc-document">
  <router-outlet></router-outlet>
</div>
